import {Navigate} from "react-router-dom"
import {useAuthStore} from "../../store/authStore"

export const ProtectedRoute: React.FC<{children: React.ReactNode}> = ({children}) => {
	const {status} = useAuthStore()

	//TODO: Add loading spinner
	if (status === "loading") {
		//return <LoadingSpinner />
	}

	if (status === "authenticated") {
		return <>{children}</>
	}

	return <Navigate to="/login" replace />
}

export const PublicRoute: React.FC<{children: React.ReactNode}> = ({children}) => {
	const {status} = useAuthStore()

	//TODO: Add loading spinner
	if (status === "loading") {
		//return <LoadingSpinner />
	}

	if (status === "authenticated") {
		return <Navigate to="/" replace />
	}

	return <>{children}</>
}
